import {
    APP_SET_GEO_INFORMATION,
    APP_SET_PAGE_ERROR,
    APP_SET_QUERY_STRING_TO_STATE,
    APP_SET_TRANSLATOR,
    APP_SET_USER_DETAILS,
    APP_SET_SIGNED_OUT,
    APP_SET_DYNAMIC_CONTENT,
    APP_SET_DTL_PAGE_NAME,
    APP_SET_IS_CHROME_INCOGNITO,
    APP_SET_CENTRAL_CONFIG,
    // GET_AB_TEST_CONFIG,
    // GET_AB_TEST_CONFIG_FULFILLED,
    // GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED,
    // GET_AB_TEST_CONFIG_REJECTED,
    SET_TEMPORARY_RESET_PASSWORD_DATA,
    SET_UPDATE_PASSWORD,
    SET_SOCIAL_ERROR,
    RESET_SOCIAL_ERROR,
    SET_SOCIAL_LOGIN_IN_PROGRESS,
    SET_EXPIREDLINK_POPUP,
    SET_MIGRATEDLINK_POPUP,
    PASSWORD_RESET_REQUIRED,
    CLOSE_PASSWORD_RESET_REQUIRED,
    SHOW_RECAPTHA_IMAGE,
    SET_SHOW_SESSION_EXPIRY_OVERLAY
} from '../actions/ActionTypes';
import { validate } from 'validate.js';
import {
    DEFAULT_BRAND,
    DEFAULT_THEME,
    VALID_BRANDS,
    VALID_LEGACY_BRANDS,
    VALID_REDIRECT_HOSTS_REGX,
    VALID_THEMES,
    VALIDATION_CONSTRAINTS,
    DEFAULT_PID,
    DEFAULT_PSID
} from '../util/AppConstant';
import { getCurrentEnv } from '@sfly/uig-current-environment-util';
import Auth from '@aws-amplify/auth';
import queryString from 'query-string';

/**
 * Initial state of the url params and other app level objects
 */
const initialState = {
    brand: null,
    theme: null,
    email: null,
    givenName: null,
    familyName: null,
    identityProvider: '',
    sflyUid: '',
    mltUid: '',
    preSchoolsUid: '',
    ltSmilesUid: '',
    cupId: '',
    source: null,
    session: null,
    contentSpace: null,
    cid: null,
    customTitle: null,
    partnerContent: null,
    partnerId: DEFAULT_PID,
    partnerSubId: DEFAULT_PSID,
    redirectUri: null,
    changeAccountUri: null,
    ssoAction: false,
    devBrands: false,
    ipSpoof: null,
    geoInformation: null,
    translator: null,
    pageLevelErrorMessage: null,
    verificationToken: null,
    dynamicContent: null,
    dtlPageName: null,
    dtlFormType: null,
    isChromeIncognito: false,
    centralConfig: { show_downtime_msg: false },
    language: 'en',
    // newPasswordSecurity: true,
    temporaryResetPasswordEmail: '',
    socialOnly: false,
    socialError: '',
    socialLoginInProgress: false,
    // showNewSignupPage: true,
    // enableConfirmEmailField: false,
    wyngPowered: false,
    ssoCheckBoxFlow: 'C_FLOW',
    costcoEncodedValue: '',
    vands1: false,
    vands2: false,
    passwordResetRequired: false,
    recapthaImageValue:null,
    code: null,
    stateCode: null,
    showSessionExpiryPopup: false,
};

/**
 * Global app level reducer to store the queryString params and other app level state objects
 * @param state
 * @param action
 * @returns {*}
 */
export function applicationReducer(state = initialState, action) {

    switch (action.type) {

        case APP_SET_QUERY_STRING_TO_STATE:

            // Go over the valid query string params and normalize them
            const cleansedParams = {};

            // New clients should pass both brand and theme
            let theme = (action.parsedQueryString.theme || '').toLowerCase();
            theme = VALID_THEMES.indexOf(theme) === -1 ? null : theme;

            const allBrands = VALID_BRANDS.concat(VALID_LEGACY_BRANDS);
            let brand = (action.parsedQueryString.brand || '').toLowerCase();
            brand = allBrands.indexOf(brand) === -1 ? null : brand;

            // New clients should pass both brand and theme
            if (theme && brand) {
                cleansedParams.theme = theme;
                cleansedParams.brand = brand;

            } else if (brand) {

                // TODO: Add Splunk logging for a dashboard of clients that need to migrate to the new theme and brand combo
                // handle legacy brand logic without a theme param
                cleansedParams.brand = brand;
                if (VALID_LEGACY_BRANDS.indexOf(brand) !== -1) {
                    // If we get a legacy brand name with no theme param then this is an old 2019 implementation, and we will set theme for them and use the default brand
                    cleansedParams.theme = brand;
                    cleansedParams.brand = DEFAULT_BRAND;
                } else if (VALID_BRANDS.indexOf(brand) !== -1) {
                    // If there is no theme but we have a valid brand then we will set the them to that
                    cleansedParams.theme = brand;
                } else if (VALID_LEGACY_BRANDS.concat(VALID_BRANDS).indexOf(brand) === -1) {
                    cleansedParams.theme = DEFAULT_THEME;
                    cleansedParams.brand = DEFAULT_BRAND;
                }

            } else if (theme) {
                // handle missing brand but possibly a theme...
                cleansedParams.theme = theme;
                if (VALID_BRANDS.indexOf(theme) !== -1) {
                    cleansedParams.brand = theme;
                } else if (VALID_THEMES.indexOf(theme) !== -1) {
                    cleansedParams.brand = DEFAULT_BRAND;
                } else {
                    cleansedParams.theme = DEFAULT_THEME;
                    cleansedParams.brand = DEFAULT_BRAND;
                }

            } else {
                // Handle not having either brand nor theme on the url
                cleansedParams.theme = DEFAULT_THEME;
                cleansedParams.brand = DEFAULT_BRAND;

            }

            // email - Has to pass validation or should not be used.
            if (action.parsedQueryString.email) {
                let email = action.parsedQueryString.email.toLowerCase();
                if (validate.single(email, VALIDATION_CONSTRAINTS.SignUp.email) === undefined) {
                    // If the param is a valid email by our standards then we use it else we leave it as null.
                    cleansedParams.email = email;
                }
            }

            if (action.parsedQueryString.code && action.parsedQueryString.state) {
                cleansedParams.code = action.parsedQueryString.code;
                cleansedParams.stateCode = action.parsedQueryString.state;
            }

            // givenName
            if (action.parsedQueryString.givenName) {
                cleansedParams.givenName = action.parsedQueryString.givenName;
            }
            // familyName
            if (action.parsedQueryString.familyName) {
                cleansedParams.familyName = action.parsedQueryString.familyName;
            }
            //firstName
            if (action.parsedQueryString.fn) {
                cleansedParams.firstNameFromQueryString = action.parsedQueryString.fn
            }
            //lastName
            if (action.parsedQueryString.ln) {
                cleansedParams.lastNameFromQueryString = action.parsedQueryString.ln
            }
            //guestCheckout
            if (action.parsedQueryString.gu) {
                cleansedParams.guestCheckOut = action.parsedQueryString.gu
            }
            // source
            if (action.parsedQueryString.source) {
                cleansedParams.source = action.parsedQueryString.source;
            }
            // session
            if (action.parsedQueryString.session) {
                cleansedParams.session = action.parsedQueryString.session;
            }
            // challengeName
            if (action.parsedQueryString.challengeName) {
                cleansedParams.challengeName = action.parsedQueryString.challengeName;
            }
            // availableIdp
            if (action.parsedQueryString.availableIdp) {
                cleansedParams.availableIdp = action.parsedQueryString.availableIdp;
            }
            // contentSpace
            if (action.parsedQueryString.contentSpace) {
                cleansedParams.contentSpace = action.parsedQueryString.contentSpace;
            }
            // cid
            if (action.parsedQueryString.cid) {

                let cid = action.parsedQueryString.cid.trim();
                if (cid === '') {
                    cid = null;
                } else if (cid.length > 16) {
                    // USER-3972 - truncate the CID param to 16 characters so signups do not fail when they are too long.
                    cid = cid.substring(0, 16);
                }
                cleansedParams.cid = cid;
            }
            // customTitle
            if (action.parsedQueryString.customTitle) {
                cleansedParams.customTitle = action.parsedQueryString.customTitle;
            }
            // partnerContent
            if (action.parsedQueryString.partnerContent) {
                cleansedParams.partnerContent = action.parsedQueryString.partnerContent.trim();
            }
            // partnerId
            if (action.parsedQueryString.pid) {
                cleansedParams.partnerId = action.parsedQueryString.pid.trim();
            }
            // partnerSubId
            if (action.parsedQueryString.psid) {
                cleansedParams.partnerSubId = action.parsedQueryString.psid.trim();
            }
            // promoCode
            if (action.parsedQueryString.promoCode) {
                cleansedParams.promoCode = action.parsedQueryString.promoCode.trim();
                // promoCode2
                if (action.parsedQueryString.promoCode2) {
                    cleansedParams.promoCode2 = action.parsedQueryString.promoCode2.trim();
                }
            }

            // wyngPowered
            if (action.parsedQueryString.wyngPowered) {
                cleansedParams.wyngPowered = action.parsedQueryString.wyngPowered
            }
            
            // redirectUri
            if (action.parsedQueryString.redirectUri) {
                let signOutUri;
                let trimmed = action.parsedQueryString.redirectUri.trim();
                if (trimmed.includes('emailVerified=true')) {
                    trimmed=trimmed.replace('true', 'shown')
                }
                if (trimmed.includes('emailVerified=false')) {
                    trimmed=trimmed.replace('false', 'shown')
                }
                if (trimmed.includes('http') || trimmed.includes('https')) {
                if (getCurrentEnv() === 'production') {
                     if(trimmed && trimmed.match(VALID_REDIRECT_HOSTS_REGX)) {
                         cleansedParams.redirectUri = trimmed;
                     } else {

                          Auth.signOut();
                          import('../util/AppUtil').then((module) => {
                          module.clearAppSession(null,'Logout')
                          })
                          import('../util/AppUtil').then((module) => {
                             signOutUri = queryString.stringifyUrl(Object.assign(queryString.parseUrl(module.getCurrentEnvironmentConfig().ssoBaseUrl), {query: {signedOut: true}}))
                          })
                          import('../util/AppUtil').then((module) => {
                             module.redirectToClient(signOutUri, null, null, null, null, null, null);
                          })
                     }
                    } else
                     if (trimmed && trimmed.match(VALID_REDIRECT_HOSTS_REGX)) {
                             cleansedParams.redirectUri = trimmed;
                      } else {
                          Auth.signOut();
                          import('../util/AppUtil').then((module) => {
                            signOutUri = queryString.stringifyUrl(Object.assign(queryString.parseUrl(module.getCurrentEnvironmentConfig().ssoBaseUrl), {query: {signedOut: true}}))
                          })
                          import('../util/AppUtil').then((module) => {
                            module.clearAppSession(null,'Logout')
                          })
                          import('../util/AppUtil').then((module) => {
                            module.redirectToClient(signOutUri, null, null, null, null, null, null);
                          })
                      }
                }
            }
            // changeAccountUri
            if (action.parsedQueryString.changeAccountUri) {
                let trimmed = action.parsedQueryString.changeAccountUri.trim();
                if (getCurrentEnv() === 'production') {
                    if(trimmed && trimmed.match(VALID_REDIRECT_HOSTS_REGX)) {
                        cleansedParams.changeAccountUri = trimmed;
                    }
                } else if (trimmed) {
                    cleansedParams.changeAccountUri = trimmed;
                }
            }
            // ssoAction
            if (action.parsedQueryString.ssoAction) {
                cleansedParams.ssoAction = action.parsedQueryString.ssoAction === 'true';
            }
            if (action.parsedQueryString.verifyguestaccount) {
                cleansedParams.verifyguestaccount = action.parsedQueryString.verifyguestaccount === 'true';
            }
            // devBrands - for developer testing
            if (action.parsedQueryString.devBrands) {
                cleansedParams.devBrands = action.parsedQueryString.devBrands === 'true';
            }
            // ipSpoof - for fake ip address testing
            if (action.parsedQueryString.ipSpoof) {
                cleansedParams.ipSpoof = action.parsedQueryString.ipSpoof;
            }
            // autofocusInput - auto focus input field on page loaded
            if (action.parsedQueryString.autofocusInput) {
                cleansedParams.autofocusInput = action.parsedQueryString.autofocusInput === 'true';
            }
            // changePasswordApi
            if (action.parsedQueryString.changePasswordApi) {
                cleansedParams.changePasswordApi = action.parsedQueryString.changePasswordApi;
            }
            // q - reset password code
            if (action.parsedQueryString.q) {
                cleansedParams.q = action.parsedQueryString.q;
            }
            // errorCode - cognito error code for reset password
            if (action.parsedQueryString.errorCode) {
                cleansedParams.errorCode = action.parsedQueryString.errorCode;
            }
            // signedOut - for header section of the page
            if (action.parsedQueryString.signedOut) {
                cleansedParams.signedOut = action.parsedQueryString.signedOut === 'true';
            }
            // passwordChanged - for header section of the page
            if (action.parsedQueryString.passwordChanged) {
                cleansedParams.passwordChanged = action.parsedQueryString.passwordChanged === 'true';
            }
            // generalError
            if (action.parsedQueryString.error) {
                cleansedParams.error = action.parsedQueryString.error;
            }
            // ccpa
            if (action.parsedQueryString.ccpa) {
                cleansedParams.ccpa = action.parsedQueryString.ccpa === 'true';
            }
            // verify by link token
            if (action.parsedQueryString.token) {
                cleansedParams.verificationToken = action.parsedQueryString.token;
            }

            // set the language
            if (action.parsedQueryString.lang) {
                cleansedParams.language = action.parsedQueryString.lang;
            }

            // set the socialOnlyFlag for resetPassword
            if (action.parsedQueryString.socialOnly) {
                cleansedParams.socialOnly = action.parsedQueryString.socialOnly === 'true';
            }
            // set the costco encoded value
            if (action.parsedQueryString.costcoencodedvalue) {
                cleansedParams.costcoEncodedValue = action.parsedQueryString.costcoencodedvalue;
            }
            // set the costco encoded value
            if (action.parsedQueryString.vands1) {
                cleansedParams.verifyAndTransfer = action.parsedQueryString.vands1 === "true" ? true : false;
            }
            // set the costco encoded value
            if (action.parsedQueryString.vands2) {
                cleansedParams.verifyAndCombine = action.parsedQueryString.vands2 === "true" ? true : false;
            }

            return Object.assign({}, state, cleansedParams);

        case APP_SET_TRANSLATOR:
            return Object.assign({}, state, { translator: action.translator });

        case APP_SET_PAGE_ERROR:
            return Object.assign({}, state, { pageLevelErrorMessage: action.pageLevelErrorMessage });

        case APP_SET_DTL_PAGE_NAME:
            return Object.assign({}, state, { dtlPageName: action.dtlPageName, dtlFormType: action.dtlFormType });

        case APP_SET_GEO_INFORMATION:
            return Object.assign({}, state, { geoInformation: action.geoInformation });

        case APP_SET_USER_DETAILS:
            return mapUserDetailsToState(state, action);

        case APP_SET_SIGNED_OUT:
            return Object.assign({}, state, { signedOut: action.signedOut });

        case APP_SET_DYNAMIC_CONTENT:
            return Object.assign({}, state, { dynamicContent: action.dynamicContent });

        case APP_SET_IS_CHROME_INCOGNITO:
            return Object.assign({}, state, { isChromeIncognito: action.isChromeIncognito });

        case APP_SET_CENTRAL_CONFIG:
            return Object.assign({}, state, { centralConfig: action.centralConfig });

        // case GET_AB_TEST_CONFIG:
        //     let newPasswordSecurity = true;
        //     let showNewSignupPage = true;
        //     let enableConfirmEmailField = false;

        //     if (action.payload.length > 0) {
        //         let newPasswordSecurityValue = action.payload.find((item) => {
        //             if (item.content)
        //                 return Object.keys(item.content)[0] === 'newPasswordSecurity'
        //             else
        //                 return false;
        //         })?.content.newPasswordSecurity;
        //         let showNewSignupPageValue = action.payload.find((item) => {
        //             if (item.content)
        //                 return Object.keys(item.content)[0] === "newSignIn";
        //             else
        //                 return false;
        //         })?.content.newSignIn;
        //         let enableConfirmEmailFieldValue = action.payload.find((item) => {
        //             if (item.content)
        //                 return Object.keys(item.content)[0] === "enableConfirmEmailField";
        //             else
        //                 return false;
        //         })?.content.enableConfirmEmailField;
                
        //         if(newPasswordSecurityValue === false) {
        //             newPasswordSecurity = false;
        //         }
        //         if (showNewSignupPageValue === false) {
        //             showNewSignupPage = false;
        //         }
        //         if (enableConfirmEmailFieldValue === true) {
        //             enableConfirmEmailField = true;
        //         }
        //     }
        //     return Object.assign({}, state, { newPasswordSecurity, showNewSignupPage, enableConfirmEmailField });

        // case GET_AB_TEST_CONFIG_NEWSIGNUP_FULFILLED:
        //     let showNewSignupPageNew = true;
        //     if (action.payload && (action.payload.newSignIn === false || action.payload.newSignIn === 'false')) {
        //         showNewSignupPageNew = false;
        //     }
        //     return Object.assign({}, state, { showNewSignupPage: showNewSignupPageNew });

        // case GET_AB_TEST_CONFIG_FULFILLED:
        //     let newPasswordSecurityNew = true;
        //     if (action.payload && (action.payload.newPasswordSecurity === false || action.payload.newPasswordSecurity === 'false')) {
        //         newPasswordSecurityNew = false;
        //     }
        //     return Object.assign({}, state, { newPasswordSecurity: newPasswordSecurityNew });



        // case GET_AB_TEST_CONFIG_REJECTED:
        //     return Object.assign({}, state, { newPasswordSecurity: true });

        case SET_TEMPORARY_RESET_PASSWORD_DATA:
            return Object.assign({}, state, { temporaryResetPasswordEmail: action.payload });

        case SET_UPDATE_PASSWORD:
            return Object.assign({}, state, { updateWeakPassword: action.payload });

        case SET_SOCIAL_ERROR: {
            const { mismatchedEmail, errorCode, provider, type } = action.payload;
            return Object.assign({}, state, { socialError: errorCode, provider, type, mismatchedEmail });
        }

        case RESET_SOCIAL_ERROR: {
            return Object.assign({}, state, { socialError: '' });
        }

        case SET_SOCIAL_LOGIN_IN_PROGRESS: {
            return Object.assign({}, state, { socialLoginInProgress: action.payload })
        }
            
        case SET_EXPIREDLINK_POPUP: {
            return Object.assign({}, state, { showExpiredPopup: action.payload })
        }
            
        case SET_MIGRATEDLINK_POPUP: {
            return Object.assign({}, state, { showMigratedPopup: action.payload })
        } 
            
        case PASSWORD_RESET_REQUIRED: {
            return Object.assign({}, state, { passwordResetRequired: true })
        }
            
        case CLOSE_PASSWORD_RESET_REQUIRED: {
            return Object.assign({}, state, { passwordResetRequired: false })
        }
            
        case SHOW_RECAPTHA_IMAGE: {
            if (!action.payload) {
                return Object.assign({}, state, { recapthaImageValue: null, recapthaImageValue1: null })
                
            }
            else if (action?.payload?.recapthaImage1) {
                return Object.assign({}, state, { recapthaImageValue1: action.payload })
            }
            return Object.assign({}, state, { recapthaImageValue: action.payload })
        }   

        case SET_SHOW_SESSION_EXPIRY_OVERLAY:
            return Object.assign({}, state, { showSessionExpiryPopup: action.payload });
        
        default:
            return state;
    }

}


// TODO: this should be in a "profile" store or something, since these are trumping the query string params the client passes.
const mapUserDetailsToState = (state, action) => {
    const newState = {};
    if (action.userDetails.payload.email) {
        newState.profileEmail = action.userDetails.payload.email;
    }
    if (action.userDetails.payload.guest_email) {
        newState.guestEmail = action.userDetails.payload.guest_email;
    }
    if (action.userDetails.payload.family_name) {
        newState.familyName = action.userDetails.payload.family_name;
    }
    if (action.userDetails.payload.given_name) {
        newState.givenName = action.userDetails.payload.given_name
    }
    if (action.userDetails.payload.sfly_uid) {
        newState.sflyUid = action.userDetails.payload.sfly_uid
    }
    if (action.userDetails.payload.sub) {
        newState.cupId = action.userDetails.payload.sub
    }
    if (action.userDetails.payload.identities && action.userDetails.payload.identities.length > 0) {
        newState.identityProvider = action.userDetails.payload.identities[0].providerName
    }
    if (action.userDetails.payload.mlt_uid) {
        newState.mltUid = action.userDetails.payload.mlt_uid
    }
    if (action.userDetails.payload.preschools_uid) {
        newState.preSchoolsUid = action.userDetails.payload.preschools_uid
    }
    if (action.userDetails.payload.ltsmiles_uid) {
        newState.ltSmilesUid = action.userDetails.payload.ltsmiles_uid
    }
    if (action.userDetails.payload.auth_time) {
        newState.authTime = action.userDetails.payload.auth_time
    }
    if (action.userDetails.jwtToken) {
        newState.idToken = action.userDetails.jwtToken
    }
    if (action.userDetails.payload.user_type) {
        newState.userType = action.userDetails.payload.user_type
    }
    if (action.userDetails.payload['cognito:groups']) {
        newState.groups = action.userDetails.payload['cognito:groups'];
    }
    return { ...state, ...newState }
}
